<ion-grid class="grid-container-editcontact mt-4">
  <ion-row>
    <ion-col *ngIf="editcontactGroup; else formLoading">
      <form
        [formGroup]="editcontactGroup"
        class="form-container form-input-ihk"
      >
        <p class="bold">Kontaktinfo</p>
        <div>
          <ion-input
            label="E-postadresse"
            labelPlacement="stacked"
            placeholder="E-post"
            type="email"
            inputmode="email"
            formControlName="epost"
            fill="outline"
            errorText="Ugyldig e-postadresse"
            helperText="Dette er kun kontaktinfo. Kontakt kundeservice om du ønsker å
            endre e-post for innlogging."
          ></ion-input>
        </div>
        <div class="mb-4">
          <ion-input
            label="Mobilnummer"
            labelPlacement="stacked"
            placeholder="Telefon"
            formControlName="mobilnummer"
            fill="outline"
            errorText="Mobilnummer må ha minst 8 siffer"
          ></ion-input>
        </div>

        <p class="mt-8 bold">Postadresse</p>

        <div *ngIf="!canChangeAddress">
          <p class="m-0">
            {{ address.StreetName }} {{ address.BuildingNumber }}
          </p>
          <p class="m-0">{{ address.PostCode }} {{ address.CityName }}</p>
          <p class="m-0" *ngIf="address.CareOf">C/O {{ address.CareOf }}</p>
          <p class="smalltext">
            Vi henter adressen fra Folkeregisteret. Kontakt kundeservice om
            adressen er feil.
          </p>
        </div>
        <div *ngIf="canChangeAddress" class="form-container">
          <div class="flex left-wide">
            <div>
              <ion-input
                label="Gatenavn"
                labelPlacement="stacked"
                type="text"
                placeholder="Adresse"
                formControlName="gatenavn"
                fill="outline"
              ></ion-input>
            </div>
            <div>
              <ion-input
                label="Husnr"
                labelPlacement="stacked"
                type="text"
                placeholder="Nummer"
                inputmode="numeric"
                formControlName="husnr"
                fill="outline"
              ></ion-input>
            </div>
          </div>
          <div class="flex right-wide">
            <div>
              <ion-input
                label="Postnr"
                labelPlacement="stacked"
                placeholder="Postnr"
                inputmode="numeric"
                (ionChange)="checkPostnr()"
                formControlName="postnummer"
                fill="outline"
              ></ion-input>
            </div>
            <div>
              <ion-input
                label="Poststed"
                labelPlacement="stacked"
                class="readonly"
                placeholder="Poststed"
                [readonly]="true"
                formControlName="adrpoststed"
                fill="outline"
              ></ion-input>
            </div>
          </div>
          <div class="mb-4">
            <ion-input
              label="C/O"
              labelPlacement="stacked"
              type="text"
              placeholder="C/O (valgfritt)"
              formControlName="careOf"
              fill="outline"
            ></ion-input>
          </div>
        </div>
      </form>
    </ion-col>
  </ion-row>
  <ion-row class="mt-8">
    <ion-col>
      <ion-button (click)="cancel()">Avbryt</ion-button>
    </ion-col>
    <ion-col>
      <ion-button
        class="dark"
        [disabled]="!editcontactGroup || !editcontactGroup.valid"
        (click)="putContact()"
        >Lagre</ion-button
      >
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <p class="warningtext">
        Det kan ta litt tid før endringen vises i appen. Vær oppmerksom på at
        det kun er kontaktinfo for brukeren som oppdateres, ikke abonnementet
        eller faktureringsmåte.
      </p>
    </ion-col>
  </ion-row>
</ion-grid>

<ng-template #formLoading>
  <div class="spinner">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
